import styled from "styled-components";
import { TabStrip } from "@progress/kendo-react-layout";
import { ReactNode } from "react";

type Props = {
  visible: boolean;
  selected: number;
  children?: ReactNode;
};

export const ToggleTabStrip = styled(TabStrip)<Props>`
  padding: 0.3rem;
  opacity: 1;
  flex-basis: 380px;
  overflow-x: hidden;
  overflow-y: hidden;
  transition: all 300ms ease 0s;

  ${(props: Props) => (props.visible ? "" : "opacity: 0;")}
  ${(props: Props) => (props.visible ? "" : "flex-basis: 0px;")}
  ${(props: Props) => (props.visible ? "" : "width: 0px;")}

  .k-content {
    min-width: 320px;
    min-height: 346px;
    max-height: 700px;
    overflow-y: auto !important;

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 6px;
      background-color: #f5f5f5;
      transition: all 300ms ease 0s;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.9);
    }
  }
`;
